module.exports = __webpack_public_path__ + "static/media/so.ba052f96.svg";